import './types';

const hideElement = (element: HTMLElement | null): void => {
    if (element) {
        element.classList.add('d-none');
    }
};

const showElement = (element: HTMLElement | null): void => {
    if (element) {
        element.classList.remove('d-none');
    }
};

const initNewsArticlesInfiniteScroll = (): void => {
    const loadMoreButton = document.getElementById('load-more-news-btn');
    const nextPage = document.querySelector('.next-page');

    hideElement(loadMoreButton);

    if (!nextPage) {
        return;
    }

    const articleContainer = document.querySelector<HTMLElement>('.article-container');

    if (!articleContainer) {
        return;
    }

    const page = parseInt(articleContainer.dataset.infiniteScrollPage || '1', 10);
    const totalPages = parseInt(articleContainer.dataset.infiniteScrollTotalPages || '1', 10);

    const infScroll = new window.InfiniteScroll(articleContainer, {
        path: '.next-page',
        append: '.article-component',
        button: '.load-more-btn',
        status: '.page-load-status',
        history: 'replace',
    });

    infScroll.on('request', () => {
        hideElement(loadMoreButton);
    });

    infScroll.on('load', () => {
        if (infScroll.loadCount % 2 === 0 && (infScroll.loadCount + page) < totalPages) {
            infScroll.loadOnScroll = false;
            showElement(loadMoreButton);
        } else {
            infScroll.loadOnScroll = true;
            hideElement(loadMoreButton);
        }
    });
};

const initNewsArticles = (): void => {
    if (typeof window.InfiniteScroll === 'undefined') {
        setTimeout(initNewsArticles, 50);

        return;
    }

    initNewsArticlesInfiniteScroll();
};

if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initNewsArticles);
} else {
    initNewsArticles();
}
